/* formatiranje za modul Akcize */
const nf = (dec) => new Intl.NumberFormat('sr-RS', { minimumFractionDigits: dec, maximumFractionDigits: dec });
const F0 = nf(0), F2 = nf(2);

export const km = (v) => (v == null ? '—' : F0.format(v));
export const lit = (v) => (v == null ? '—' : F2.format(v));
export const din = (v) => (v == null ? '—' : F2.format(v));
export const pot = (v) => (v == null ? '—' : F2.format(v));

const MESECI = ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar'];
/** 'YYYY-MM' -> 'jan 2024' / 'januar 2024' */
export const mesecNaziv = (k, kratko = false) => {
    const [g, m] = String(k).split('-').map(Number);
    const n = MESECI[m - 1] || '';
    return `${kratko ? n.slice(0, 3) : n} ${g}`;
};
export const mesecIzBroja = (m) => MESECI[m - 1] || '';

/** datum (Date ili 'YYYY-MM-DD') -> 'dd.mm.yyyy' */
export const datum = (v) => {
    if (!v) return '—';
    if (v instanceof Date) return `${String(v.getDate()).padStart(2, '0')}.${String(v.getMonth() + 1).padStart(2, '0')}.${v.getFullYear()}`;
    const [g, m, d] = String(v).slice(0, 10).split('-');
    return d ? `${d}.${m}.${g}` : String(v);
};
/** datum za API: Date ili string -> 'YYYY-MM-DD' */
export const isoDatum = (v) => {
    if (!v) return null;
    if (v instanceof Date) return `${v.getFullYear()}-${String(v.getMonth() + 1).padStart(2, '0')}-${String(v.getDate()).padStart(2, '0')}`;
    return String(v).slice(0, 10);
};

export const NIVO = {
    greska: { label: 'Greška', icon: 'pi pi-times-circle', cls: 'danger' },
    upozorenje: { label: 'Upozorenje', icon: 'pi pi-exclamation-triangle', cls: 'warn' },
    info: { label: 'Napomena', icon: 'pi pi-info-circle', cls: 'info' },
};
